import PriceCatalogPage from './PriceCatalogPage';

export default PriceCatalogPage;
